/* ===========================================================================
   AutoFxMart — Velocity Contact behaviour (deferred).
   Reveal + accessible client-side form enhancement (blur validation, error
   summary + focus management, aria-invalid/described-by) layered on Shopify's
   native {% form 'contact' %} (server validation still applies). Spam: honeypot
   + time-trap. Copy-to-clipboard. All progressive — works without JS.
   =========================================================================== */
(function () {
  if (window.__afxContactInit) return;
  window.__afxContactInit = true;
  document.documentElement.classList.add('afx-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal */
  function initReveal() {
    var els = document.querySelectorAll('.afx-rv:not(.in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      var hits = [];
      ents.forEach(function (en) { if (en.isIntersecting) { hits.push(en.target); io.unobserve(en.target); } });
      if (hits.length) requestAnimationFrame(function () { hits.forEach(function (e) { e.classList.add('in'); }); });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { document.querySelectorAll('.afx-rv:not(.in)').forEach(function (e) { e.classList.add('in'); }); }, 2200);
  }

  /* copy to clipboard */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-afx-copy]');
    if (!b) return;
    e.preventDefault();
    var txt = b.getAttribute('data-afx-copy');
    try { navigator.clipboard.writeText(txt); } catch (x) {}
    var live = document.getElementById('afx-copy-live');
    if (live) { live.textContent = txt + ' copied'; setTimeout(function () { live.textContent = ''; }, 2000); }
    var old = b.getAttribute('data-label') || b.textContent;
    b.setAttribute('data-label', old);
  }, false);

  /* smooth scroll */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-afx-scroll]');
    if (!a) return;
    var sel = a.getAttribute('href'); if (!sel || sel.charAt(0) !== '#') return;
    var t = document.querySelector(sel); if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 60, behavior: reduce ? 'auto' : 'smooth' });
  }, false);

  /* ── form: accessible client-side validation ── */
  var form = document.getElementById('afx-c-form-el');
  if (form) {
    var mountAt = Date.now();
    var rules = {
      'contact[Topic]': function (v) { return v.trim() ? '' : 'Choose a topic so we can route it.'; },
      'contact[name]': function (v) { return v.trim() ? '' : 'Enter your name.'; },
      'contact[email]': function (v) { v = v.trim(); if (!v) return 'Enter your email address.'; return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) ? '' : 'That email doesn\u2019t look right.'; },
      'contact[body]': function (v) { return v.trim() ? '' : 'Tell us what you need.'; }
    };
    var fieldEl = function (name) { return form.querySelector('[name="' + name + '"]'); };
    var errEl = function (el) { return document.getElementById(el.id + '-err'); };

    function setErr(el, msg) {
      var e = errEl(el);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (e) { e.textContent = msg; e.classList.toggle('show', !!msg); }
      return !!msg;
    }
    function validateField(name) { var el = fieldEl(name); if (!el || !rules[name]) return false; return setErr(el, rules[name](el.value)); }

    // validate on blur; clear on input once errored
    Object.keys(rules).forEach(function (name) {
      var el = fieldEl(name); if (!el) return;
      el.addEventListener('blur', function () { validateField(name); }, false);
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') validateField(name); }, false);
      el.addEventListener('change', function () { if (el.getAttribute('aria-invalid') === 'true') validateField(name); }, false);
    });

    form.addEventListener('submit', function (ev) {
      // honeypot
      var hp = form.querySelector('[name="company_url"]');
      if (hp && hp.value) { ev.preventDefault(); return; }
      // time-trap
      if (Date.now() - mountAt < 3000) { ev.preventDefault(); flash('One sec — then send.'); return; }
      // validate all
      var bad = [];
      Object.keys(rules).forEach(function (name) { if (validateField(name)) bad.push(name); });
      if (bad.length) {
        ev.preventDefault();
        buildSummary(bad);
        return;
      }
      // ok → let Shopify submit; disable to prevent double-post
      var btn = form.querySelector('.afx-submit');
      if (btn) { btn.setAttribute('disabled', ''); var l = btn.querySelector('[data-afx-submit-label]'); if (l) l.textContent = 'Sending…'; }
    }, false);

    function buildSummary(bad) {
      var box = document.getElementById('afx-c-summary');
      if (!box) return;
      var labels = { 'contact[Topic]': 'Topic', 'contact[name]': 'Name', 'contact[email]': 'Email', 'contact[body]': 'Message' };
      var items = bad.map(function (name) {
        var el = fieldEl(name);
        var msg = (errEl(el) && errEl(el).textContent) || labels[name];
        return '<li><a href="#' + el.id + '" data-afx-jump="' + el.id + '">' + msg + '</a></li>';
      }).join('');
      box.querySelector('[data-afx-count]').textContent = bad.length === 1 ? '1 field' : bad.length + ' fields';
      box.querySelector('ul').innerHTML = items;
      box.hidden = false;
      box.focus();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-afx-jump]');
      if (!a) return; e.preventDefault();
      var el = document.getElementById(a.getAttribute('data-afx-jump')); if (el) el.focus();
    }, false);
  }

  var toastT;
  function flash(msg) {
    var t = document.getElementById('afx-c-toast');
    if (!t) { t = document.createElement('div'); t.id = 'afx-c-toast'; t.setAttribute('role', 'status'); t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:80;padding:12px 18px;border-radius:100px;background:var(--ink,#16110F);color:var(--bg,#fff);font:600 14px/1 system-ui;box-shadow:0 20px 40px -20px rgba(0,0,0,.5)'; document.body.appendChild(t); }
    t.textContent = msg; t.style.opacity = '1';
    clearTimeout(toastT); toastT = setTimeout(function () { t.style.opacity = '0'; }, 2000);
  }

  /* on success, move focus to the confirmation heading (Liquid renders it) */
  var ok = document.getElementById('cf-success-h');
  if (ok) { try { ok.focus(); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal); else initReveal();
  document.addEventListener('shopify:section:load', initReveal);
})();
